module.exports = __webpack_public_path__ + "img/1F6AB.4736598d.svg";